import { useCallback, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Splash } from "../components/Splash";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Collaboration } from "../components/Collaboration";
import { ActionList } from "../components/ActionList";
import { ShareSection } from "../components/ShareSection";
import { Disclaimer } from "../components/Disclaimer";

export default function Home() {
  const [ready, setReady] = useState(false);
  const done = useCallback(() => setReady(true), []);

  return (
    <>
      <AnimatePresence>{!ready && <Splash onDone={done} />}</AnimatePresence>
      <Header />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <div className="mx-auto grid max-w-6xl gap-20 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Collaboration />
            </div>
          </div>
          <div className="lg:col-span-7">
            <ActionList />
          </div>
        </div>
        <div className="mx-auto max-w-6xl px-5 pb-24 sm:px-8">
          <ShareSection />
        </div>
      </main>
      <Disclaimer />
    </>
  );
}
